<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M61.56 21.94a1.49 1.49 0 00-2.12 0L55 26.38V11a2 2 0 00-2-2H11a2 2 0 00-2 2v10a1.5 1.5 0 003 0v-9h40v14.38l-4.44-4.44a1.5 1.5 0 00-2.12 2.12l6.65 6.65a2 2 0 002.82 0l6.65-6.65a1.49 1.49 0 000-2.12zM53.5 41.5A1.5 1.5 0 0052 43v9H12V37.37l4.44 4.44a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12L11.91 33a2 2 0 00-2.82 0l-6.65 6.69a1.5 1.5 0 002.12 2.12L9 37.37V53a2 2 0 002 2h42a2 2 0 002-2V43a1.5 1.5 0 00-1.5-1.5z"/></svg>